import React, { useEffect } from "react";
import { useStore } from "../../../contexts/StoreProvider";
import ScheduleFirmwareUpdateForm from "../forms/schedule-firmware-update-form";
import {
  getLoggedInTenantIdFromLocalStorage,
} from "../../../helpers/local-stotrage-helper";
import { formatMessage } from "../../../translations/format-message";
import { observer } from "mobx-react";
import { ISelectOption } from "../../../models/ICommon";
import { fotaView, TIME_FORMAT } from "../../../constants/common-constants";
import { IAddReleaseScheduler } from "../../../models/Form/IAddUpdateReleaseScheduler";
import moment from "moment";

interface IProps {
  schedulerId: number;
  releaseId: number;
  version: string;
  view: string;
  modalClosed: () => void;
}

const ScheduleFirmwareUpdate = (props: IProps) => {
  const { releaseSchedulerHistoryStore, groupStore } = useStore();
  const {
    addUpdateReleaseSchedulerHistoryState,
    inProgress,
    resetAddUpdateReleaseSchedulerHistoryState,
    UpdateReleaseSchedulerHistoryService,
    AddReleaseSchedulerHistoryService,
    GetReleaseSchedulerHistoryByIdService,
    releaseSchedulerHistoryState,
    getReleaseSchedulerHistory,
    resetReleaseSchedulerHistoryState
  } = releaseSchedulerHistoryStore;
  const { GetAllGroupService, allAllGroupOptions } = groupStore;

  /**
   * The useEffect Hook lets you perform side effects in function component.
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered
   * while a dependency of the useEffect has changed.
   */
  useEffect(() => {
      GetAllGroupService(getLoggedInTenantIdFromLocalStorage());
      if(props.schedulerId > 0)
        GetReleaseSchedulerHistoryByIdService(props.schedulerId, props.view)
  }, [props.schedulerId]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "addUpdateUserSuccess" of the useEffect changed.
   */
  useEffect(() => {
    if (addUpdateReleaseSchedulerHistoryState.success) {
      // if (props.schedulerId > 0)
      //   toast.success(formatMessage("updated_success"));
      // else
      //   toast.success(formatMessage("added_success"));
      onModalClosed();
    }
  }, [addUpdateReleaseSchedulerHistoryState.success]);

  const submithandler = (data: IAddReleaseScheduler) => {
    let isAllOptionSelected = data.GroupIds.filter(
      (gp: ISelectOption) => gp.id === -1
    );
    let selectedGroupIdList: Array<number> =
      isAllOptionSelected.length > 0
        ? [...allAllGroupOptions].map((gp: ISelectOption) => gp.id)
        : [...data.GroupIds].map((gp: ISelectOption) => gp.id);
    let payload: any = {
      ScheduleDate: data.IsUpdateNow === "1"
      ? `${data.ScheduleDate} ${moment().format(TIME_FORMAT)}`
      : data.ScheduleDate,
      Description: data.Description,
      IsAppliedOnGroup: data.IsAppliedOnGroup === "true" ? true : false,
      GroupIds:
        data.IsAppliedOnGroup === "true"
          ? selectedGroupIdList.filter((id: number) => id !== -1)
          : [],
      ICCIDs: data.ICCIDs,
    };
    if(props.schedulerId > 0){
      payload = {...payload, Id: props.schedulerId, ReleaseId: props.releaseId, WantToUpdateDevices: data.WantToUpdateDevices === "true" ? true : false }
      UpdateReleaseSchedulerHistoryService(payload, props.view);
    }
    else{
      payload = {...payload, IsUpdateNow: data.IsUpdateNow === "1" ? true : false};
      AddReleaseSchedulerHistoryService(payload, props.view, props.releaseId);
    }
  };

  /**
   * This function closes the pop up modal and reset getuserdetails, addUpdate user observables (success, inprogress
   * and error).
   */
  const onModalClosed = () => {
    resetAddUpdateReleaseSchedulerHistoryState();
    resetReleaseSchedulerHistoryState();
    props.modalClosed();
  };
  
  const getTitle = () => {
    let title = "";
    switch(props.view)
    {
      case fotaView.JET:
        title = formatMessage("jet_version");
      break;
      case fotaView.MODEM:
        title = formatMessage("modem_version");
      break;
      default:
        title = formatMessage("host_version");
      break;
    }
    title = props.schedulerId > 0 ? `${formatMessage("update_schedule")} (${title} ${props.version} ${formatMessage("firmware")})` : 
      `${formatMessage("add_schedule")} (${title} ${props.version} ${formatMessage("firmware")})`;
    return title;
  };

  return (
    <ScheduleFirmwareUpdateForm
      schedulerId={props.schedulerId}
      initialValues={getReleaseSchedulerHistory}
      title={getTitle()}
      groupOptions={allAllGroupOptions}
      submitHandler={submithandler}
      onModalClosed={onModalClosed}
      dataLoading={releaseSchedulerHistoryState.inProgress || inProgress}
      actionLoading={addUpdateReleaseSchedulerHistoryState.inProgress}
    />
  );
};

export default observer(ScheduleFirmwareUpdate);
